module.exports = __webpack_public_path__ + "img/ic_newmail.1b993b23.svg";